import {createSlice} from "@reduxjs/toolkit";
import { getUserList } from './action';

const initialState = {
  state: {
    items: [],
    paging: {}
  },
  loading: true,
  error: ''
} as BaseState<UserState>

const slice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserList.pending, (state) => ({
        ...state,
        loading: true
      })
    )
    builder.addCase(getUserList.fulfilled, (state, action) => {
        const { items, paging } = action.payload
        return {
          state: { items, paging },
          loading: false,
          error: null
        }
      }
    )
    builder.addCase(getUserList.rejected, (state) => ({
        ...state,
        loading: false,
        error: 'Failed to get customers, please try again'
      })
    )
  }
})

export default slice
